// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e2c77a9a","488":"5db084f8","539":"e1b44875","564":"7c1038ea"}[chunkId] + ".chunk.js";
};